"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    InteractionTag: function() {
        return _InteractionTag.InteractionTag;
    },
    InteractionTagPrimary: function() {
        return _InteractionTagPrimary.InteractionTagPrimary;
    },
    InteractionTagSecondary: function() {
        return _InteractionTagSecondary.InteractionTagSecondary;
    },
    Tag: function() {
        return _Tag.Tag;
    },
    TagGroup: function() {
        return _TagGroup.TagGroup;
    },
    interactionTagClassNames: function() {
        return _InteractionTag.interactionTagClassNames;
    },
    interactionTagPrimaryClassNames: function() {
        return _InteractionTagPrimary.interactionTagPrimaryClassNames;
    },
    interactionTagSecondaryClassNames: function() {
        return _InteractionTagSecondary.interactionTagSecondaryClassNames;
    },
    renderInteractionTagPrimary_unstable: function() {
        return _InteractionTagPrimary.renderInteractionTagPrimary_unstable;
    },
    renderInteractionTagSecondary_unstable: function() {
        return _InteractionTagSecondary.renderInteractionTagSecondary_unstable;
    },
    renderInteractionTag_unstable: function() {
        return _InteractionTag.renderInteractionTag_unstable;
    },
    renderTagGroup_unstable: function() {
        return _TagGroup.renderTagGroup_unstable;
    },
    renderTag_unstable: function() {
        return _Tag.renderTag_unstable;
    },
    tagClassNames: function() {
        return _Tag.tagClassNames;
    },
    tagGroupClassNames: function() {
        return _TagGroup.tagGroupClassNames;
    },
    useInteractionTagContextValues_unstable: function() {
        return _InteractionTag.useInteractionTagContextValues_unstable;
    },
    useInteractionTagPrimaryStyles_unstable: function() {
        return _InteractionTagPrimary.useInteractionTagPrimaryStyles_unstable;
    },
    useInteractionTagPrimary_unstable: function() {
        return _InteractionTagPrimary.useInteractionTagPrimary_unstable;
    },
    useInteractionTagSecondaryStyles_unstable: function() {
        return _InteractionTagSecondary.useInteractionTagSecondaryStyles_unstable;
    },
    useInteractionTagSecondary_unstable: function() {
        return _InteractionTagSecondary.useInteractionTagSecondary_unstable;
    },
    useInteractionTagStyles_unstable: function() {
        return _InteractionTag.useInteractionTagStyles_unstable;
    },
    useInteractionTag_unstable: function() {
        return _InteractionTag.useInteractionTag_unstable;
    },
    useTagAvatarContextValues_unstable: function() {
        return _utils.useTagAvatarContextValues_unstable;
    },
    useTagGroupContextValues_unstable: function() {
        return _TagGroup.useTagGroupContextValues_unstable;
    },
    useTagGroupStyles_unstable: function() {
        return _TagGroup.useTagGroupStyles_unstable;
    },
    useTagGroup_unstable: function() {
        return _TagGroup.useTagGroup_unstable;
    },
    useTagStyles_unstable: function() {
        return _Tag.useTagStyles_unstable;
    },
    useTag_unstable: function() {
        return _Tag.useTag_unstable;
    }
});
const _Tag = require("./Tag");
const _InteractionTag = require("./InteractionTag");
const _InteractionTagPrimary = require("./InteractionTagPrimary");
const _InteractionTagSecondary = require("./InteractionTagSecondary");
const _TagGroup = require("./TagGroup");
const _utils = require("./utils");
